import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "m4.622 1.866.974.974-2.958 2.958h14.874a3.445 3.445 0 0 1 3.445 3.446.69.69 0 0 1-1.378 0 2.067 2.067 0 0 0-2.067-2.067H2.638l2.958 2.958-.974.974L0 6.488l4.622-4.622Zm14.756 11.025-.974.974 2.958 2.958H5.11a2.067 2.067 0 0 1-2.067-2.067.69.69 0 1 0-1.378 0 3.445 3.445 0 0 0 3.445 3.445h16.252l-2.958 2.959.974.974L24 17.512l-4.622-4.621Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }